var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.812,
    height: 17,
    viewBox: "0 0 12.812 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30515",
    "data-name": "Group 30515",
    transform: "translate(-2.334 -2.334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1070",
    "data-name": "Group 1070",
    transform: "translate(2.834 2.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11888",
    "data-name": "Path 11888",
    d: "M28.5,16.185H22.329a1.494,1.494,0,0,1-1.494-1.494V4.328a1.494,1.494,0,0,1,1.494-1.494h4.144a1.494,1.494,0,0,1,1.064.446l2.03,2.061A1.494,1.494,0,0,1,30,6.389v8.3A1.494,1.494,0,0,1,28.5,16.185Z",
    transform: "translate(-18.186 -2.834)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fc8a06",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11889",
    "data-name": "Path 11889",
    d: "M12,31.467v1.224A1.494,1.494,0,0,1,10.5,34.185H4.328a1.494,1.494,0,0,1-1.494-1.494V22.328a1.494,1.494,0,0,1,1.494-1.494H5.2",
    transform: "translate(-2.834 -18.185)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fc8a06",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    "data-name": "Line 67",
    x2: 5.071,
    transform: "translate(4.436 4.763)",
    fill: "none",
    stroke: "#fc8a06",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_68",
    "data-name": "Line 68",
    x2: 3.427,
    transform: "translate(4.436 7.007)",
    fill: "none",
    stroke: "#fc8a06",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_69",
    "data-name": "Line 69",
    x2: 1.891,
    transform: "translate(4.436 9.251)",
    fill: "none",
    stroke: "#fc8a06",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11890",
    "data-name": "Path 11890",
    d: "M61.452,5.9V7.221a1.494,1.494,0,0,0,1.494,1.494H64.27",
    transform: "translate(-52.825 -5.446)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fc8a06",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsIcon);
export default __webpack_public_path__ + "static/media/documentsIcon.2499b32d4e67dc16acf054a4cc784d80.svg";
export { ForwardRef as ReactComponent };